module.exports = __webpack_public_path__ + "img/location_pin.bf282170.svg";